export function OutlineSackDollarIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.032 6L8.03198 3H16.0336L13.0336 6H11.032Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0321 18.9984C18.6689 21 15.6161 21 12.0305 21C8.44488 21 5.39208 21 4.02888 18.9984C2.06088 16.1136 5.06568 11.1984 7.02888 9C8.09448 7.8048 9.70728 6 12.0305 6C14.3537 6 15.9665 7.8048 17.0321 9C18.9953 11.2032 22.0001 16.1136 20.0321 18.9984Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0321 11.6261C13.6961 11.4005 12.9809 10.9925 12.0305 11.0021C11.6321 11.0021 10.6577 11.0117 10.2737 11.6261C10.0673 11.9573 10.0193 12.4853 10.2737 12.8741C10.9457 13.9013 13.1201 13.0949 13.7921 14.1221C14.0465 14.5109 14.0033 15.0389 13.7921 15.3701C13.4177 15.9653 12.4961 15.9845 12.0929 15.9941C11.1185 16.0181 10.3841 15.6005 10.0337 15.3701"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M12.0305 9V11.0016" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M12.0305 15.998V17.9996" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}
